export enum NotificationType {
  INSTALLMENT = 'installment',
  PROMOTION = 'promotion',
  SOCIAL = 'social'
}
